module.exports = __webpack_public_path__ + "img/4.d3a9a336.jpeg";